<template>
  <div class="courier">
    <vue-a-map></vue-a-map>
  </div>
</template>

<script>
import vueAMap from '../../components/vueAMap'
export default {
  name: 'courier',
  components: {
    vueAMap
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Courier/Courier.vue